// G1 is approved, so the founder photo ships. To withdraw it, replace this module with
// `const founderPhoto = null; export default founderPhoto;` and set MK_FLAGS.FOUNDER_NOTE_APPROVED
// to false in the same commit — MkFounderNote then renders the team-signed fallback.
import founderPhoto from '../assets/images/mk/mk-founder-giorgi-226x300.webp';

export default founderPhoto;
